import type { DialogConfig } from '@svenskaspelab/nova-foundation/nextjs/dialog';
import { cancelDoneMw } from '@svenskaspelab/nova-payment-sport';
import { createElement } from 'react';

import { getFormattedCurrency } from '../../lib/entry.browser.js';

/**
 * Creates a cancel done middleware with the provided showDialog function.
 *
 * @param showDialog Dialog function to show confirmation dialog
 * @param callbackOnDone Optional callback function to call after successful cancellation
 * @returns Cancel done middleware
 */
export function cancelDone(
  showDialog: (props: DialogConfig, meta?: string[]) => Promise<void>,
  callbackOnDone?: () => void
): ReturnType<typeof cancelDoneMw> {
  return cancelDoneMw(
    (cancelContext) =>
      new Promise((resolve, reject) => {
        const { title, message } = cancelContext || {};
        showDialog({
          title: title,
          description: createElement('p', { className: 'text-center lg:text-left' }, message || ''),
          buttons: {
            primary: {
              label: 'Okej',
              action: () => {
                resolve(); // Continue with cancellation
              },
            },
          },
        }).catch(() => {
          // If the dialog is closed in another way (ESC, click outside, etc.)
          reject(new Error('Cancel done dialog was closed prematurely'));
        });
      }),
    callbackOnDone,
    getFormattedCurrency
  );
}
